// A mutation that refreshes every query afterwards. Simple and always right for a portal this size: after any
// change, every screen shows what the API now answers (the fixture is in memory, so this is instant).
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { CampaignApi } from './CampaignApi'
import { useApi } from './ApiProvider'

export function useChange<Input, Answer>(change: (api: CampaignApi, input: Input) => Promise<Answer>) {
  const api = useApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: Input) => change(api, input),
    onSuccess: () => queryClient.invalidateQueries(),
  })
}
